const $ = window.jQuery;
const $window = window.$window || $(window);
// core version + navigation, pagination modules:
import Tabit from "tabit";

const SwiperCarousel = {
  init() {
    var $module = $("#tabs");
    if (!$module.length) return;

    $module.each((index, element) => {
      this.each(element);
    });
  },

  each(element) {
    const tabsElement = document.getElementById("tabs");
    const options = {
      buttonSelector: "[data-target]",
      buttonActiveClass: "active",
      contentSelector: "[data-content]",
      buttonAttribute: "data-target",
      contentAttribute: "data-content",
      contentActiveClass: "active",
    };
    if (document.getElementById("tabs")) {
      /* eslint-disable no-new */
      new Tabit(tabsElement, options);
    }
  },
};

export default SwiperCarousel;
